import { KVMessageDef } from './index'

interface CameraPoseMessage {
  cameraViewPosition: string
  cameraViewRotation: string
  fov?: number
}

interface CameraPoseData {
  position: string
  rotation: string
  fov: number
}

type CameraPoseResolver = (data: CameraPoseData | null) => void

let currentCameraPoseResolver: CameraPoseResolver | null = null

export function registerCurrentCameraPoseRequest(resolver: CameraPoseResolver) {
  currentCameraPoseResolver = resolver
}

export function unregisterCurrentCameraPoseRequest() {
  currentCameraPoseResolver = null
}

export function getCurrentCameraPoseResultMessage(): KVMessageDef {
  return {
    type: 'currentCameraPose',
    requiredData: ['cameraViewPosition', 'cameraViewRotation'],

    callback: (json: Record<string, unknown>) => {
      const message = json as unknown as CameraPoseMessage
      if (currentCameraPoseResolver) {
        currentCameraPoseResolver({
          position: message.cameraViewPosition,
          rotation: message.cameraViewRotation,
          fov: message.fov ?? 60,
        })
        currentCameraPoseResolver = null
      }
    },
  }
}
